<template>
  <div class="scrollColor hidden overflow-auto md:flex md:shrink-0">
    <div class="flex w-64 flex-col">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div
        class="min-h-0 flex flex-1 flex-col border-r border-secondary-200 bg-default"
      >
        <div class="flex flex-1 flex-col overflow-y-auto pt-5 pb-4">
          <div
            class="m-auto flex shrink-0 items-center px-4"
            :class="[getTypeFromImage === 'svg' ? '' : 'h-[32px] w-[240px]']"
            v-if="!brokenImage"
          >
            <img
              v-if="logo"
              :src="logo"
              :alt="clientId"
              :class="[
                getTypeFromImage !== 'svg' ? 'object-contain' : 'h-8 w-auto',
              ]"
              @error="imageLoadOnError"
              aria-label="logo image"
              data-testid="desktop-app-logo"
            />
          </div>
          <h1 v-else class="text-center font-semibold text-4xl">
            {{ clientId }}
          </h1>

          <nav
            class="mt-5 flex-1 space-y-1 bg-default px-2"
            aria-label="menu links"
          >
            <div class="flex flex-col px-4 py-4">
              <span class="inline-flex rounded-md shadow-sm" id="newMessage">
                <RouterLink
                  to="/message-compose"
                  class="inline-flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-4 py-2 text-sm font-medium leading-5 text-default transition duration-150 ease-in-out hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                >
                  New Message
                </RouterLink>
              </span>
            </div>
            <div
              v-if="getMenuItemsHasError && getMenuItems.length == 0"
              class="px-4 py-4 font-medium uppercase tracking-wider text-secondary-500"
            >
              Error in fetching data. Please try again
            </div>
            <div v-else id="sideMenus" data-testid="desktop-menu-links">
              <DesktopMenuItem
                v-for="menu in getMenuItems"
                :service="menu.service"
                :label="menu.label"
                :key="menu.id"
                :unreadMessageCount="unreadMessageCount"
              />
            </div>
          </nav>
        </div>
        <slot name="bottom" />
        <ProfileAvatar />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ProfileAvatar from "@/components/profile-avatar.vue";
import { computed, ref } from "vue";
import DesktopMenuItem from "@/components/menu/desktop-menu/desktop-menu-item.vue";
import { storeToRefs } from "pinia";
import { useMenuStore } from "@/pinia/useMenuStore";
import { useAuthStore } from "@/pinia/useAuthStore";

defineProps({
  unreadMessageCount: {
    type: Number,
    default: 0,
  },
});
const { getMenuItems, getMenuItemsHasError } = storeToRefs(useMenuStore());
const { getUserProfile, getLogoURL } = storeToRefs(useAuthStore());

const clientId = getUserProfile.value?.decodedData?.brand ?? "CONNECT3";
const brokenImage = ref(false);
const getTypeFromImage = computed(() => {
  if (getLogoURL.value) {
    const parts = getLogoURL.value.split(".");
    return parts[parts.length - 1];
  }
});

const imageLoadOnError = (e: any) => {
  e.target.style.display = "none";
  brokenImage.value = true;
};

const logo = computed(() => {
  if (getLogoURL.value) {
    return new URL(getLogoURL.value, window.location.origin).href;
  }
});
</script>

<style scoped>
.scroll-overlay:hover {
  overflow-y: overlay;
}

*::-webkit-scrollbar-thumb {
  background-color: rgb(229 231 235);
}
</style>
